import { ApiKy } from './index'
import {
  CurrentStatus,
  HealthCheckIncident,
  HealthCheckProbe,
  MonitoringDateRangeSearchParams,
  MonitoringIncidentsSearchParams,
  OpenIncidentStatus,
} from '~/types/monitoring'

function toSearchParams(searchParams: MonitoringDateRangeSearchParams) {
  const params = new URLSearchParams()
  params.set('from', searchParams.from)
  params.set('to', searchParams.to)
  searchParams.incidentType?.forEach((incidentType) =>
    params.append('incidentType', incidentType),
  )
  return params
}

export default class Api extends ApiKy {
  getHealthCheckProbes(searchParams: MonitoringDateRangeSearchParams) {
    return this.ky
      .get(`${this.url}/health-check-probes`, {
        searchParams: toSearchParams(searchParams),
      })
      ?.json<HealthCheckProbe[]>()
  }

  getHealthCheckIncidents(searchParams: MonitoringIncidentsSearchParams) {
    const params = toSearchParams(searchParams)
    if (searchParams.orderBy) {
      params.set('orderBy', searchParams.orderBy)
      params.set('asc', String(searchParams.asc))
    }

    return this.ky
      .get(`${this.url}/health-check-incidents`, {
        searchParams: params,
      })
      ?.json<HealthCheckIncident[]>()
  }

  getHealthCheckAvailability(searchParams: MonitoringDateRangeSearchParams) {
    return this.ky
      .get(`${this.url}/health-check-availability`, {
        searchParams: toSearchParams(searchParams),
      })
      ?.json<number>()
  }

  getCurrentStatus() {
    return this.ky.get(`${this.url}/current-status`)?.json<CurrentStatus[]>()
  }

  getOpenIncidentStatus() {
    return this.ky
      .get(`${this.url}/health-check-incidents/open`)
      ?.json<OpenIncidentStatus>()
  }
}
